// apps/web/src/components/SDGIcon.tsx

"use client"

import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip"
import Image from "next/image"

interface SDGIconProps {
  number: number
  title: string
  iconUrl: string
  size?: number
  className?: string
}

export function SDGIcon({ number, title, iconUrl, size = 80, className = "" }: SDGIconProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          className={`inline-block cursor-pointer transition-all duration-300 hover:scale-110 ${className}`}
          role="img"
          aria-label={`SDG ${number}: ${title}`}
          style={{
            width: `${size}px`,
            height: `${size}px`,
            minWidth: `${size}px`,
            minHeight: `${size}px`,
          }}
        >
          <Image
            src={iconUrl}
            alt={`SDG ${number}: ${title}`}
            width={size}
            height={size}
            className="object-cover rounded-sm"
            loading="lazy"
            quality={85}
          />
        </div>
      </TooltipTrigger>
      <TooltipContent
        sideOffset={8}
        className="bg-brand-1 text-slate-900 border border-slate-200 rounded-lg px-3 py-2 text-xs max-w-xs"
      >
        <div className="text-center">
          <p className="font-semibold text-blue-600">SDG {number}</p>
          <p className="text-xs text-slate-700 leading-tight">{title}</p>
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
